__turbopack_context__.v({
  "card": "Home-module__g21JLG__card",
  "code": "Home-module__g21JLG__code",
  "container_usefull": "Home-module__g21JLG__container_usefull",
  "description": "Home-module__g21JLG__description",
  "footer": "Home-module__g21JLG__footer",
  "grid": "Home-module__g21JLG__grid",
  "logo": "Home-module__g21JLG__logo",
  "main": "Home-module__g21JLG__main",
  "title": "Home-module__g21JLG__title",
});
